// frontend/src/pages/public/LegalPage.jsx
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Seo from "../../marketing/Seo";
import Markdown from "../../marketing/Markdown";
import { getLegalDoc, LEGAL_LAST_UPDATED } from "../../marketing/data/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const doc = getLegalDoc(slug);
  if (!doc) return <Navigate to="/legal" replace />;

  return (
    <article>
      <Seo title={doc.title} description={doc.description} path={`/legal/${doc.slug}`} />
      <p className="text-sm text-gray-500">Last updated: {LEGAL_LAST_UPDATED}</p>
      <Markdown>{doc.body}</Markdown>
    </article>
  );
}
